<template>
  <transition name="modal">
    <div v-if="!d_minimized" :class="[d_maximized ? 'full-screen-mode' : 'modal fade show modal-mask']" id="myModal" tabindex="-1" role="dialog">
      <div :class="f_calculateClass()" role="document" :style="CalculateStyle()">
        <div class="modal-content">
          <b-row>
            <b-col sm="12" md="9">
              <slot name="header"> {{ $t('wdm16.4080') }} </slot>
            </b-col>
            <b-col sm="12" md="3" v-if="!p_hideButtons">
              <b-button class="pull-right" @click="$emit('close')" :title="$t('wdm16.4045')" style="margin-right: 0px; padding: 0px; border: solid 1px #5d7d75;">
                <img src="@/icon/1890926.png" style="width: 2em;">
              </b-button>
              <b-button class="pull-right" @click="d_minimized = true" style="margin-right: 3px; padding: 0px; border: solid 1px #5d7d75;" :title="$t('wdm16.11211')">
                <img src="@/icon/45774.png" style="width: 2em;">
              </b-button>
              <b-button variant="secondary" class="pull-right" @click="d_maximized === true ? d_maximized = false : d_maximized = true " style="margin-right: 3px; padding: 0px; border: solid 1px #5d7d75;" :title="$t('wdm16.6589')">
                <img src="@/icon/900293.png" style="width: 2em;">
              </b-button>
            </b-col>
          </b-row>
          <div class="modal-body" id="body_content" :style="'height: ' + height + 'px'">
            <p>
              <slot name="body">
                {{ $t('wdm16.4046') }}
              </slot>
            </p>
          </div>
          <div class="modal-footer" v-if="footer">
            <b-col> <img src="../../../public/img/favicon.png" style="width: 33px; height: 33px;"> </b-col>
            <b-col> <img v-if="hospital_logo" :src="hospital_logo" style="width: 33px; height: 33px;"> </b-col>
            <slot name="footer">
              <button type="button" class="btn btn-primary" style="margin-right: 3px;">{{ $t('wdm16.4196') }}</button>
              <button type="button" class="btn btn-danger" @click="$emit('close')" style="margin-right: 3px;">{{ $t('wdm16.4053') }}</button>
            </slot>
          </div>
        </div>
      </div>
    </div>
    <div v-if="d_minimized" style="position: fixed; bottom: 30px; right: 0px;">
      <b-button variant="warning" data-dismiss="modal" @click="d_minimized ? d_minimized = false : d_minimized = true" style="margin-right: 3px; width: 100px;" :title="$t('wdm16.6589')">
        <img src="@/icon/900293.png" style="width: 2em;">
      </b-button>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    large: {
      required: false,
      default: false
    },
    width: {
      required: false,
      type: String
    },
    footer: {
      type: Boolean,
      required: false,
      default: true
    },
    modal_class: {
      type: String,
      required: false,
      default: ''
    },
    p_hideButtons: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  created: function () {
    this.height = screen.height * 70 / 100;
    this.user = JSON.parse(localStorage.getItem('user'));
    let hos_data = JSON.parse(localStorage.getItem('hospital_data'));
    if (hos_data && hos_data.logo && hos_data.logo.logo_1) {
      this.hospital_logo = hos_data.logo.logo_1;
    }
    if (this.modal_class) {
      this.modal_cls = this.modal_class;
    }
  },
  data () {
    return {
      d_minimized: false,
      d_maximized: false,
      height: '',
      hospital_data: {},
      user: {},
      modal_cls: '',
      hospital_logo: ''
    };
  },
  methods: {
    f_calculateClass: function () {
      if (this.d_maximized) {
        return 'full-screen-mode';
      } else {
        if (this.large) {
          return 'modal-dialog modal-lg';
        } else {
          return 'modal-dialog';
        }
      }
    },
    CalculateStyle: function () {
      if (this.d_maximized) {
        return 'width: 100%';
      }
      if (this.width) {
        if (this.width.indexOf('%') !== -1) {
          return 'width: ' + this.width.replace('%', '') + '%; height: 90%;';
        } else {
          return 'max-width: ' + this.width + 'px; height: 90%;';
        }
      } else {
        return 'height: 90%;';
      }
    }
  }
};

</script>

<style type="text/css">
.modal-mask {
  position: fixed;
  z-index: 1021;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-body {
  overflow-y: auto;
  overflow-x: hidden;
}

.modal-header {
  padding: 0.3px;
}

.modal-footer {
  padding: 0.3px;
}

#body_content::-webkit-scrollbar-track {
  border-radius: 5px;
  background-color: #d9e9ea;
}

#body_content::-webkit-scrollbar {
  width: 10px;
  background-color: #F5F5F5;
}

#body_content::-webkit-scrollbar-thumb {
  border-radius: 100px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
  background-color: #4788ac;
}

.full-screen {
  z-index: 1021;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /*background-color: rgba(0, 0, 0, .5);*/
  display: table;
  -webkit-transition: opacity .3s ease;
  transition: opacity .3s ease;
}

.full-screen-mode {
  position: fixed;
  z-index: 1021;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  /*background-color: rgba(0, 0, 0, .5);*/
  /*display: table;*/
  -webkit-transition: opacity .3s ease;
  transition: opacity .3s ease;
}

</style>

